import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
    {
        path: 'main',
        loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'main/:from',
        loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'profiles',
        loadChildren: () => import('./profiles/profiles.module').then((m) => m.ProfilesModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'document',
        loadChildren: () => import('./document/document.module').then((m) => m.DocumentModule),
        canActivate: [MsalGuard]
    },
    {
        path: 'settings',
        loadComponent: () =>
            import('./settings/components/settings/settings.component').then((m) => m.SettingsComponent),
        canActivate: [MsalGuard]
    },
    {
        path: '**',
        redirectTo: 'main'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
